import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { business, navigation } from '../config/siteData';
import { Logo } from './Layout';

export function FinalCTA() {
  return (
    <section className="final-cta">
      <span className="eyebrow">The next stay starts now</span>
      <h2>Your Next Guest Is Coming.</h2>
      <p>Let The Cleaning Bees handle everything between checkout and check-in.</p>
      <div>
        <a className="button button-light" href="#quote">Request a Turnover Quote</a>
        <a className="text-link light-link" href="#quote">Contact Us <SafeIcon icon={FiIcons.FiArrowUpRight} /></a>
      </div>
    </section>
  );
}

export function Footer() {
  const socialLinks = [
    ['Instagram', business.socials.instagram, FiIcons.FiInstagram],
    ['Facebook', business.socials.facebook, FiIcons.FiFacebook],
    ['WhatsApp', business.socials.whatsapp, FiIcons.FiMessageCircle]
  ];

  return (
    <footer className="footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <Logo light />
          <p>Austin's Short-Term Rental Turnaround Experts</p>
        </div>
        <div>
          <strong>Navigate</strong>
          {navigation.map(([label, id]) => <a key={id} href={`#${id}`}>{label}</a>)}
          <a href="#quote">Contact</a>
        </div>
        <div>
          <strong>Services</strong>
          <a href="#services">Rental Turnovers</a>
          <a href="#services">Off-Site Laundry</a>
          <a href="#services">Inventory &amp; Restocking</a>
          <a href="#services">Light Maintenance</a>
        </div>
        <div>
          <strong>Connect</strong>
          {socialLinks.map(([label, url, icon]) => (
            <a href={url} key={label} target="_blank" rel="noreferrer">
              <SafeIcon icon={icon} /> {label}
            </a>
          ))}
        </div>
      </div>
      <div className="footer-bottom">
        <span>© 2026 The Cleaning Bees. All rights reserved.</span>
        <div><a href="#privacy">Privacy Policy</a><a href="#terms">Terms of Service</a></div>
      </div>
    </footer>
  );
}